<template>
  <div class="menu">
    <loading :active.sync="isLoading"></loading>
    <modal name="categoriesModal" :adaptive="true" scrollable :width="900" height="auto" class="overflow-y-scroll">
      <h3 class="text-center text-xl font-bold mt-4 mb-6">{{ $t('Categories') }}</h3>
      <div
        v-for="(category, index) in categories"
        :key="index"
        class="flex align-center justify-between w-1/2 mx-auto my-3 border rounded-lg shadow-lg px-4 py-4"
      >
        <div style="line-height: 40px;" class="text-lg">{{ category }}</div>
        <div>
          <eva-icon
            class="mr-3"
            name="arrow-ios-downward-outline"
            animation="pulse"
            :width="40"
            :height="40"
            fill="#4299E1"
            @click="handleMoveCategory({ index, direction: 'down' })"
          />
          <eva-icon
            class="mx-3"
            name="arrow-ios-upward-outline"
            animation="pulse"
            :width="40"
            :height="40"
            fill="#4299E1"
            @click="handleMoveCategory({ index, direction: 'up' })"
          />
          <eva-icon
            class="ml-2"
            name="trash-outline"
            animation="pulse"
            :width="40"
            :height="40"
            fill="#c53030"
            @click="handleDeleteCategory(index)"
          />
        </div>
      </div>
      <div class="flex align-center justify-between w-1/2 mx-auto my-3 border rounded-lg shadow-lg px-4 py-4">
        <input
          class="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          type="text"
          :placeholder="$t('New Category')"
          v-model="newCategory"
          @keyup.enter="handleAddNewCategory"
        />
        <button
          class="flex items-center mr-2 rounded-full bg-blue-400 text-center px-6 py-2 font-light text-white"
          type="button"
          @click="handleAddNewCategory"
        >
          {{ $t('Add New') }}
        </button>
      </div>

      <div class="flex justify-center my-6">
        <button
          class="rounded-full bg-green-400 text-center px-8 py-2 mx-auto font-light text-white"
          type="button"
          @click="handleSaveCategoryChanges"
        >
          {{ $t('Save Changes') }}
        </button>
      </div>
    </modal>
    <modal name="menuModal" :adaptive="true" scrollable :width="800" height="auto" class="vld-parent">
      <loading :active.sync="isLoading" :isFullPage="false"></loading>
      <h3 class="text-center my-6">{{ menuItem.mode === 'add' ? $t('Add New Menu') : $t('Edit') }} {{ $t('Item') }}</h3>
      <form class="px-8" autocomplete="off">
        <div class="flex justify-between">
          <div class="w-1/2">
            <div class="mb-4">
              <validation-provider name="Name" rules="required" v-slot="{ errors }">
                <label class="block text-gray-700 text-sm font-bold mb-2" for="name">
                  {{ $t('Name') }}
                </label>
                <input
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="name"
                  type="text"
                  :placeholder="$t('Name')"
                  v-model="menuItem.name"
                />
                <span class="text-red-700">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="mb-6">
              <validation-provider name="Price" rules="required" v-slot="{ errors }">
                <label class="block text-gray-700 text-sm font-bold mb-2" for="price">
                  {{ $t('Price') }}
                </label>
                <input
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="price"
                  type="text"
                  :placeholder="$t('Price')"
                  v-model="menuItem.price"
                />
                <span class="text-red-700">{{ errors[0] }}</span>
              </validation-provider>
            </div>

            <label class="block mb-6">
              <validation-provider name="Description" v-slot="{ errors }">
                <span class="text-gray-700">{{ $t('Description') }}</span>
                <textarea
                  class="form-textarea mt-1 block w-full"
                  rows="2"
                  v-model="menuItem.description"
                  :placeholder="$t('Description')"
                ></textarea>
                <span class="text-red-700">{{ errors[0] }}</span>
              </validation-provider>
            </label>

            <label class="block mb-6">
              <span class="text-gray-700">{{ $t('Category') }}</span>
              <select class="form-select mb-6 w-full" v-model="menuItem.category">
                <option v-for="(category, index) in categories" :value="category" :key="index">{{ category }}</option>
              </select>
            </label>

            <div class="mb-6 text-center flex flex-col justify-center">
              <label class="block text-gray-700 text-sm font-bold mb-2 mr-2"> {{ $t('Available') }}? </label>
              <div>
                <eva-icon
                  class="mr-2"
                  name="checkmark-circle-2-outline"
                  animation="pulse"
                  :width="40"
                  :height="40"
                  :fill="menuItem.available ? '#68d391' : '#4A5568'"
                  @click="menuItem.available = true"
                />
                <eva-icon
                  class="ml-2"
                  name="close-circle-outline"
                  animation="pulse"
                  :width="40"
                  :height="40"
                  :fill="!menuItem.available ? '#c53030' : '#4A5568'"
                  @click="menuItem.available = false"
                />
              </div>
            </div>
          </div>
          <div class="w-1/2">
            <div v-if="tmpImage.url" class="mb-4">
              <div class="flex justify-between pb-2">
                <h4>{{ $t('Current Image') }}:</h4>
                <eva-icon
                  class="ml-2"
                  name="trash-outline"
                  animation="pulse"
                  width="30"
                  height="30"
                  fill="#c53030"
                  @click="handleDeleteImage"
                />
              </div>
              <img :src="tmpImage.url" alt="Menu Item Image" />
            </div>
            <div class="mb-6 text-center flex justify-center">
              <label
                class="w-40 flex flex-col items-center px-4 py-6 rounded-lg shadow-lg tracking-wide uppercase border border-blue cursor-pointer"
                :class="{
                  'bg-white': !tmpImage.file,
                  'bg-green-400': tmpImage.file,
                  'text-black': !tmpImage.file,
                  'text-white': tmpImage.file,
                }"
              >
                <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path
                    d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z"
                  />
                </svg>
                <span class="mt-2 text-base leading-normal">{{
                  tmpImage.file ? $t('Uploaded') : $t('Select an image')
                }}</span>
                <input type="file" ref="imageUpload" class="hidden" @change="handleImageUpload" />
              </label>
            </div>
          </div>
        </div>
        <div class="flex justify-center mb-6">
          <button
            class="flex items-center mr-2 rounded-full bg-green-400 text-center px-6 py-2 font-light text-white"
            type="button"
            @click="handleCreate"
          >
            {{ menuItem.mode === 'add' ? $t('Add New') : $t('Edit') }}
          </button>
          <button
            class="flex items-center ml-2 rounded-full bg-blue-400 text-center px-6 py-2 font-light text-white"
            type="button"
            @click="handleClose"
          >
            {{ $t('Close') }}
          </button>
        </div>
      </form>
    </modal>

    <modal name="deleteCategoryConfirmModal" :adaptive="true" :width="300" :height="300">
      <h3 class="text-center my-6 mx-6">
        {{
          $t(
            'Are you sure you want to delete this category? This will hide menu items in this category until you change them.',
          )
        }}
      </h3>
      <div class="flex justify-center mt-4">
        <button
          class="flex items-center rounded-full bg-blue-400 text-center px-6 py-2 font-light text-white mr-2"
          type="button"
          @click="$modal.hide('deleteCategoryConfirmModal')"
        >
          {{ $t('No') }}
        </button>
        <button
          class="flex items-center rounded-full bg-red-700 text-center px-6 py-2 font-light text-white ml-2"
          type="button"
          @click="categories.splice(deleteCategoryIndex) && $modal.hide('deleteCategoryConfirmModal')"
        >
          {{ $t('Yes, delete!') }}
        </button>
      </div>
    </modal>

    <modal name="deleteConfirmModal" :adaptive="true" :width="300" :height="200">
      <h3 class="text-center my-6 mx-6">{{ $t('Are you sure you want to delete this item?') }}</h3>
      <div class="flex justify-center mt-4">
        <button
          class="flex items-center rounded-full bg-blue-400 text-center px-6 py-2 font-light text-white mr-2"
          type="button"
          @click="cancelConfirmDelete"
        >
          {{ $t('No') }}
        </button>
        <button
          class="flex items-center rounded-full bg-red-700 text-center px-6 py-2 font-light text-white ml-2"
          type="button"
          @click="handleDelete"
        >
          {{ $t('Yes, delete!') }}
        </button>
      </div>
    </modal>

    <section class="admin-menu-container bg-white shadow-xl mt-10 mx-10 rounded-lg px-4 py-8">
      <div class="flex justify-between items-center">
        <h2 class="text-xl">{{ $t('Menu') }}</h2>
        <div class="flex">
          <button
            class="flex items-center rounded-full bg-indigo-400 text-center px-6 py-2 font-light text-white mr-2"
            @click="handleShowCategories"
          >
            {{ $t('Categories') }}
          </button>
          <button
            class="flex items-center rounded-full bg-green-400 text-center px-6 py-2 font-light text-white"
            @click="handleAddNew"
          >
            {{ $t('Add New') }}
            <eva-icon class="ml-4" name="plus-outline" animation="pulse" width="20" height="20" fill="#fff"></eva-icon>
          </button>
        </div>
      </div>
      <div class="w-full mt-6">
        <table class="w-full table-fixed">
          <thead class="text-left">
            <tr>
              <th class="px-4 py-2 w-1/12">#</th>
              <th class="px-4 py-2 w-3/12">{{ $t('Name') }}</th>
              <th class="px-4 py-2 w-3/12">{{ $t('Description') }}</th>
              <th class="px-4 py-2 w-1/12">{{ $t('Price') }}</th>
              <th class="px-4 py-2 w-2/12">{{ $t('Available') }}</th>
              <th class="px-4 py-2 w-2/12">{{ $t('Actions') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr class="border-t border-b" v-for="(item, index) in menu" :key="index">
              <td class="px-4 py-2">{{ index + 1 }}</td>
              <td class="px-4 py-2">{{ item.name }}</td>
              <td class="px-4 py-2">{{ item.description }}</td>
              <td class="px-4 py-2">{{ item.price.toFixed(2) }}</td>
              <td class="px-4 py-2 text-center">
                <eva-icon
                  v-if="item.available"
                  name="checkmark-circle-2-outline"
                  animation="pulse"
                  :width="tableIconSize"
                  :height="tableIconSize"
                  fill="#68d391"
                />
                <eva-icon
                  v-if="!item.available"
                  name="close-circle-outline"
                  animation="pulse"
                  :width="tableIconSize"
                  :height="tableIconSize"
                  fill="#c53030"
                />
              </td>
              <td class="py-2 text-center">
                <eva-icon
                  class="mr-2"
                  name="edit-2-outline"
                  animation="pulse"
                  :width="tableIconSize"
                  :height="tableIconSize"
                  fill="#4A5568"
                  @click="handleEdit(index)"
                />
                <eva-icon
                  class="ml-2"
                  name="trash-outline"
                  animation="pulse"
                  :width="tableIconSize"
                  :height="tableIconSize"
                  fill="#c53030"
                  @click="handleDeleteConfirm(index)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import { db, auth, storage } from '@/firebase';

export default {
  name: 'Menu',
  data() {
    return {
      isLoading: false,
      tableIconSize: 30,
      menu: [],
      categories: [],
      newCategory: '',
      menuItem: {
        name: '',
        price: '',
        category: '',
        available: true,
        mode: 'add',
        description: '',
        imageRef: '',
      },
      delete: null,
      deleteCategoryIndex: null,
      tmpImage: {
        ref: null,
        file: null,
        url: null,
      },
    };
  },
  async created() {
    this.isLoading = true;
    const { uid } = auth.currentUser;
    const restaurant = await db
      .collection('restaurants')
      .doc(uid)
      .get();

    if (restaurant.exists) {
      const { menu, menuCategories } = restaurant.data();
      if (menu) {
        this.menu = menu;
      }
      if (menuCategories) {
        this.categories = menuCategories;
      }
    }
    this.isLoading = false;
  },
  methods: {
    handleDeleteImage() {
      this.menuItem.imageRef = '';
      this.tmpImage = {
        ref: null,
        file: null,
        url: null,
      };
    },
    handleDeleteCategory(index) {
      this.deleteCategoryIndex = index;
      this.$modal.show('deleteCategoryConfirmModal');
    },
    async handleSaveCategoryChanges() {
      const { uid } = auth.currentUser;
      this.isLoading = true;
      try {
        await db
          .collection('restaurants')
          .doc(uid)
          .update({ menuCategories: this.categories });
        this.isLoading = false;
        this.$modal.hide('categoriesModal');
      } catch (e) {
        console.log('e :', e);
      }
    },
    handleMoveCategory({ index, direction }) {
      const move = direction === 'up' ? -1 : 1;
      this.categories.splice(index + move, 0, this.categories.splice(index, 1)[0]);
    },
    handleAddNewCategory() {
      this.categories.push(this.newCategory);
      this.newCategory = '';
    },
    handleShowCategories() {
      this.$modal.show('categoriesModal');
    },
    handleAddNew() {
      this.menuItem = {
        name: '',
        price: '',
        available: true,
        category: '',
        mode: 'add',
        index: this.menu.length,
        description: '',
        imageRef: '',
      };
      this.tmpImage.url = null;

      this.$modal.show('menuModal');
    },
    async handleEdit(index) {
      const { name, price, available, description, imageRef, category } = this.menu[index];
      if (imageRef !== '') {
        const url = await storage
          .ref()
          .child(imageRef)
          .getDownloadURL();
        this.tmpImage.url = url;
      } else {
        this.tmpImage.url = null;
      }

      this.menuItem = {
        name,
        price,
        available,
        mode: 'edit',
        category,
        index,
        description,
        imageRef,
      };

      this.$modal.show('menuModal');
    },
    async handleCreate() {
      this.isLoading = true;
      const { uid } = auth.currentUser;
      const { ref, file } = this.tmpImage;
      const { mode, name, price, available, index, description, imageRef, category } = this.menuItem;
      const newMenuItem = { name, price: parseFloat(price), available, description, category };
      const newMenu = this.menu.slice();

      if (ref) {
        newMenuItem.imageRef = ref.fullPath;
      } else {
        newMenuItem.imageRef = imageRef;
      }

      if (mode === 'add') {
        try {
          await ref.put(file);
        } catch (e) {
          console.log(e);
        }

        newMenu.push(newMenuItem);
      }
      if (mode === 'edit') {
        if (ref) {
          try {
            await ref.put(file);
          } catch (e) {
            console.log(e);
          }
        }
        newMenu[index] = newMenuItem;
      }
      try {
        await db
          .collection('restaurants')
          .doc(uid)
          .update({ menu: newMenu });
        this.menu = newMenu;
        this.menuItem = {
          name,
          price,
          available,
          category,
          mode: 'edit',
        };
        this.$refs.imageUpload.value = null;
        this.tmpImage = {
          ref: null,
          file: null,
          url: null,
        };
        this.isLoading = false;
        this.$modal.hide('menuModal');
      } catch (e) {
        console.log('e :', e);
      }
    },
    handleDeleteConfirm(index) {
      this.$modal.show('deleteConfirmModal');
      this.delete = index;
    },
    cancelConfirmDelete() {
      this.delete = null;
      this.$modal.hide('deleteConfirmModal');
    },
    async handleDelete() {
      const { uid } = auth.currentUser;
      const index = this.delete;

      const newMenu = this.menu.slice();
      newMenu.splice(index, 1);

      try {
        await db
          .collection('restaurants')
          .doc(uid)
          .update({ menu: newMenu });
        this.menu = newMenu;
        this.$modal.hide('deleteConfirmModal');
      } catch (e) {
        console.log('e :', e);
      }
    },
    handleClose() {
      this.$modal.hide('menuModal');
    },
    handleImageUpload(e) {
      const { uid } = auth.currentUser;
      const f = e.target.files[0];
      const { type } = f;
      if (type) {
        const ext = type.split('/')[1];
        const imageUid = new Date().valueOf().toString();

        this.tmpImage.ref = storage.ref().child(`${uid}/${imageUid}.${ext}`);
        this.tmpImage.file = f;
      }
    },
  },
};
</script>
<style lang="scss">
.admin-menu-container {
  height: 80vh;
}
select {
  /* for Firefox */
  -moz-appearance: none;
  /* for Chrome */
  -webkit-appearance: none;
}

/* For IE10 */
select::-ms-expand {
  display: none;
}
</style>
